import { render, staticRenderFns } from "./DialogTagDicom.vue?vue&type=template&id=3a6aa9e5"
import script from "./DialogTagDicom.vue?vue&type=script&lang=js"
export * from "./DialogTagDicom.vue?vue&type=script&lang=js"
import style0 from "./DialogTagDicom.vue?vue&type=style&index=0&id=3a6aa9e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports